import React from 'react';
import { TOUCH_TARGETS } from '../theme/tokens';
import './HomeScreen.css';

interface HomeScreenProps {
  onStartGame: () => void;
}

const HomeScreen: React.FC<HomeScreenProps> = ({ onStartGame }) => {
  return (
    <div className="home-screen">
      <div className="home-container">
        {/* Decoración de fondo */}
        <div className="background-decoration">
          <div className="floating-star star-1">✨</div>
          <div className="floating-star star-2">⭐</div>
          <div className="floating-star star-3">✨</div>
          <div className="floating-star star-4">⭐</div>
          <div className="floating-star star-5">✨</div>
        </div>

        {/* Contenido principal */}
        <div className="home-content">
          <div className="cata-cover">
            <img 
              src="/assets/Cover.png" 
              alt="Princesa Cata" 
              className="cata-image"
            />
          </div>
          
          <div className="title-section">
            <h1 className="main-title">
              El Reino de la Princesa Cata ✨👑
            </h1>
            <p className="subtitle">
              Toca <strong>Jugar Ahora</strong> para elegir una lección y aprender.
            </p>
          </div>

          <div className="magic-items-preview">
            <div className="item-preview">🌸</div>
            <div className="item-preview">👑</div>
            <div className="item-preview">💎</div>
            <div className="item-preview">🦄</div>
          </div>

          <div className="button-group">
            <button 
              className="play-button primary"
              onClick={onStartGame}
              style={{
                minHeight: TOUCH_TARGETS.minSize,
                padding: TOUCH_TARGETS.padding
              }}
            >
              ¡Jugar ahora!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeScreen;
